import { Component, inject, OnInit } from '@angular/core';
import { BaryComponentHelper } from '../../../../shared/util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../models/bary-modal-event';
import { FormControl, FormGroup } from '@angular/forms';
import { BasketOrder } from '../../../../../models/basket-order.model';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { PaymentMethodEnum } from '../../../../../models/enums/payment-method.enum';
import { FaDirectiveEnum } from '../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-modal-customer-confirmation-differed-payment',
  templateUrl: './modal-customer-confirmation-differed-payment.component.html',
  styleUrls: ['./modal-customer-confirmation-differed-payment.component.scss'],
})
export class ModalCustomerConfirmationDifferedPaymentComponent implements OnInit {
  private readonly modalRef = inject(MDBModalRef);

  public basketOrderList?: BasketOrder[];
  public deferredBillsNoPaidAmountCumulated: number = 0;
  public deferredBillsNoPaidBillNumbers: string = '';

  protected readonly FAS = FaDirectiveEnum.FAS;

  private TRANSFERT_DEFERRED = PaymentMethodEnum.INIT_TRANSFERT_DEFERRED;

  private action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  private controls!: {
    userTypology: FormControl;
  };
  private baryForm!: FormGroup;

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  ngOnInit(): void {
    this.controls = {
      userTypology: new FormControl(this.TRANSFERT_DEFERRED),
    };
    this.baryForm = new FormGroup(this.controls);
    if (this.basketOrderList && this.basketOrderList.length > 0) {
      this.deferredBillsNoPaidAmountCumulated = this.basketOrderList.reduce((acc, currentValue) => acc + currentValue.price!, 0);
      this.basketOrderList.forEach((its, idx) => {
        if (idx === (this.basketOrderList || []).length - 1) {
          this.deferredBillsNoPaidBillNumbers += its.billNumber;
        } else {
          this.deferredBillsNoPaidBillNumbers += its.billNumber + ', ';
        }
      });
    }
  }

  submit(): void {
    this.action.next(new BaryModalEvent({ submit: true }));
    this.modalRef.hide();
  }

  handleSubmit(): void {
    if (this.baryForm.invalid) {
      this.baryForm.markAllAsTouched();
    } else {
      this.action.next(new BaryModalEvent({ submit: true, value: this.baryForm.value }));
      this.modalRef.hide();
    }
  }
}
